// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));
    z-index: 10;
    box-sizing: border-box;
}
.login-form-container{
    width: 100%;
    padding: 0;
    margin-top: auto;
    margin-bottom: auto;
}

.alert-notice{
    position: absolute;
    bottom:10%;
    left: 0;
    right: 0;
    text-align: center;
    background-color: #fff;
    border-radius: 30px;
    padding: 20px
}
.login-form__input{
    width: 100%;
}

.login-form__restore-password{
    text-align: center;
    text-decoration: underline;
    text-decoration-color: var( --app-text-color-secondary)!important;
    color: var( --app-text-color-secondary) ;
    font-size: 1rem;
    font-weight: 400;
}

.login-form .login-form__help-button {
    margin-bottom: 16px;
}

.login-form__help-button span{
    text-transform: none;
    text-align: center;
    text-decoration: underline;
    text-decoration-color: var( --app-text-color-secondary)!important;
    color: var( --app-text-color-secondary) ;
    font-size: 1rem;
    font-weight: 400;
}

.login-form__field-container {
    padding-bottom: 32px;
}
.login-form__field-container--password,
.login-form__field-container--checkbox{
    padding-bottom: 25px;
}
.login-form__action-btn-container .main-action-btn{
    margin-bottom: 32px;
}
.login-form__action-btn-container{
    text-align: center;
}
.login-form__field-container--lang{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.login-form__input.MuiInputBase-root,.MuiFormControl-root {
    outline: none!important;
}
.login-form__input.MuiInputBase-root:focus, .MuiFormControl-root:focus  {
    border-color: var(--app-border-secondary-color);
    outline: none!important;
}
.login-form__input.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
.login-form__input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
    border-color: var(--app-border-secondary-color);
    border-width: 1px;
}
.MuiFormLabel-root.Mui-focused {
    color: var(--app-border-secondary-color);
    font-weight: bold;
}
.login-form__input .MuiOutlinedInput-input{
    padding: 15px 16px;
}
.login-form__input .MuiOutlinedInput-notchedOutline{
    border-color: var(--app-border-secondary-color-v30);
}
.login-form__field-container .MuiInputLabel-outlined{
    transform: translate(14px, 16px) scale(1)!important;
}
.login-form__field-container .MuiInputLabel-outlined.MuiInputLabel-shrink{
    transform: translate(14px, -6px) scale(0.75)!important;
}
.MuiInputLabel-outlined.MuiInputLabel-shrink{
    background-color: white;
}
.login-form__field-container--lang .app-logo{
    visibility: hidden;
    width: 0;
}
@media screen and (min-width: 680px){
    .login-form__field-container--lang .app-logo{
        visibility: visible;
    }
}


`, "",{"version":3,"sources":["webpack://./src/pages/Login/components/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,uDAAuD;IACvD,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,iEAAiE;IACjE,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,iEAAiE;IACjE,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,+CAA+C;IAC/C,uBAAuB;AAC3B;AACA;;IAEI,+CAA+C;IAC/C,iBAAiB;AACrB;AACA;IACI,wCAAwC;IACxC,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mDAAmD;AACvD;AACA;IACI,mDAAmD;AACvD;AACA;IACI,sDAAsD;AAC1D;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".login-form{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    background-color: white;\n    border-top-left-radius: 30px;\n    border-top-right-radius: 30px;\n    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));\n    z-index: 10;\n    box-sizing: border-box;\n}\n.login-form-container{\n    width: 100%;\n    padding: 0;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.alert-notice{\n    position: absolute;\n    bottom:10%;\n    left: 0;\n    right: 0;\n    text-align: center;\n    background-color: #fff;\n    border-radius: 30px;\n    padding: 20px\n}\n.login-form__input{\n    width: 100%;\n}\n\n.login-form__restore-password{\n    text-align: center;\n    text-decoration: underline;\n    text-decoration-color: var( --app-text-color-secondary)!important;\n    color: var( --app-text-color-secondary) ;\n    font-size: 1rem;\n    font-weight: 400;\n}\n\n.login-form .login-form__help-button {\n    margin-bottom: 16px;\n}\n\n.login-form__help-button span{\n    text-transform: none;\n    text-align: center;\n    text-decoration: underline;\n    text-decoration-color: var( --app-text-color-secondary)!important;\n    color: var( --app-text-color-secondary) ;\n    font-size: 1rem;\n    font-weight: 400;\n}\n\n.login-form__field-container {\n    padding-bottom: 32px;\n}\n.login-form__field-container--password,\n.login-form__field-container--checkbox{\n    padding-bottom: 25px;\n}\n.login-form__action-btn-container .main-action-btn{\n    margin-bottom: 32px;\n}\n.login-form__action-btn-container{\n    text-align: center;\n}\n.login-form__field-container--lang{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.login-form__input.MuiInputBase-root,.MuiFormControl-root {\n    outline: none!important;\n}\n.login-form__input.MuiInputBase-root:focus, .MuiFormControl-root:focus  {\n    border-color: var(--app-border-secondary-color);\n    outline: none!important;\n}\n.login-form__input.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,\n.login-form__input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{\n    border-color: var(--app-border-secondary-color);\n    border-width: 1px;\n}\n.MuiFormLabel-root.Mui-focused {\n    color: var(--app-border-secondary-color);\n    font-weight: bold;\n}\n.login-form__input .MuiOutlinedInput-input{\n    padding: 15px 16px;\n}\n.login-form__input .MuiOutlinedInput-notchedOutline{\n    border-color: var(--app-border-secondary-color-v30);\n}\n.login-form__field-container .MuiInputLabel-outlined{\n    transform: translate(14px, 16px) scale(1)!important;\n}\n.login-form__field-container .MuiInputLabel-outlined.MuiInputLabel-shrink{\n    transform: translate(14px, -6px) scale(0.75)!important;\n}\n.MuiInputLabel-outlined.MuiInputLabel-shrink{\n    background-color: white;\n}\n.login-form__field-container--lang .app-logo{\n    visibility: hidden;\n    width: 0;\n}\n@media screen and (min-width: 680px){\n    .login-form__field-container--lang .app-logo{\n        visibility: visible;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
